import { ConsentHelper, ConsentHelperForm } from '../../common/ConsentHubV2';

declare const FEATURE_FLAG_USE_GDPR: boolean;

type NewsletterParams = {
  formId: string,
  needsConsent: boolean,
  site: string,
  subscriptionKey: string
};

export default class Newsletter {
  MAILING_LIST_ID: string;
  params: NewsletterParams;
  consentHub?: ConsentHelper;
  useGdpr = FEATURE_FLAG_USE_GDPR;

  constructor() {
    this.MAILING_LIST_ID = "1275007";
    this.params = {
      // Use formId from `wac/git-signup`
      formId: '16869aaa-b359-4f8a-a268-2364450cc4d7',
      needsConsent: false,
      site: "atlassian",
      subscriptionKey: "atlassian.gitInsidersNewsletter"
    }

    this.bindEvents();
  }

  addMultipleListeners(element: Element | null, events: Array<string>, handler: any, capture: boolean) {
    if (!(events instanceof Array)) {
      return false;
    }
    const handlerFn = function (this: Element) {
      handler.apply(this, []);
    }
    for (let i = 0; i < events.length; i += 1) {
      element?.addEventListener(events[i], handlerFn, capture);
    }
  }

  submitForm(event: Event) {
    event.preventDefault();
    const form = ((event.target as HTMLElement)?.tagName == "FORM" ? event.target : (event.target as HTMLElement)?.closest('form')) as ConsentHelperForm;
    const button = (form?.querySelector('[type="submit"]') as HTMLElement);
    const success = function () {
      form?.classList.remove("form-is-processing");
      button.classList.add("icon-email-success");
      button.classList.remove("icon-email-error", "icon-email-submit");
    };
    const fail = function () {
      form.classList.remove("form-is-processing");
      button.classList.remove("icon-email-success");
      button.classList.add("icon-email-error", "icon-email-submit");
    };
    form.classList.add("form-is-processing");

    if (this.useGdpr) {
      this.consentHub = new ConsentHelper(this.params, form);
      this.consentHub.configPromise.then((consentHelper: ConsentHelper) => {
        consentHelper.submitForm(success, fail);
        return consentHelper;
      }).catch(() => {
        fail();
        return null;
      });
    }

    if (!this.useGdpr) {
      const email = (form?.querySelector("._input") as HTMLInputElement)?.value;
      const exactTargetUrl = `https://www.atlassian.com/apis/exact-target/${email}/subscribe?mailingListId=${this.MAILING_LIST_ID}`;

      const postNewsletter = new XMLHttpRequest();
      postNewsletter.open('POST', exactTargetUrl, true);
      postNewsletter.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
      postNewsletter.onreadystatechange = function () {
        if (postNewsletter.status === 200) {
          success();
        } else {
          fail();
        }
      };
      postNewsletter.send();

    }
  }

  emailValidate(field: HTMLInputElement) {
    const email = field.value;
    if (email.match(/^(.+?)@(.+?)\.(.+?)$/)) {
      (field.parentNode as HTMLElement)?.classList.add("is-valid");
    } else {
      (field.parentNode as HTMLElement)?.classList.remove("is-valid");
    }
  }

  bindEvents() {
    const formNewsletter = document.querySelectorAll('form.newsletter');

    for (let f = 0; f < formNewsletter.length; f++) {
      const individualForm = formNewsletter[f];

      individualForm.addEventListener("submit", (event) => {
        this.submitForm(event);
      });

      individualForm.querySelector('._input')?.addEventListener("focus", function (this: Element) {
        (this.parentNode as HTMLElement)?.classList.add("is-focused");
      });

      individualForm.querySelector('._input')?.addEventListener("blur", function (this: Element) {
        (this.parentNode as HTMLElement)?.classList.remove("is-focused");

      });

      this.addMultipleListeners(
        individualForm.querySelector('._input'),
        ["propertychange change click keyup input paste"],
        this.emailValidate,
        false);
    }
  }
}
